<div class="aya-summary">
  <div class="aya-summary__header">
    <div class="aya-summary__header__title">Academic Year Abroad - {{ language }}</div>
    <div class="aya-summary__header__body">
      <ng-container *ngIf="programsShown">
        <p>Let your students choose from 3 flexible programs:</p>
        <p>
          <span class="aya-summary__header__body--bold">Language and Culture, University Preparation, or Professional Preparation,</span>
          with the option to switch programs and adjust fees as needed.
        </p>
      </ng-container>
      <h4>Our Academic Year Abroad includes:</h4>
      <p>{{ included }}</p>
    </div>
  </div>
</div>
